import { Component, Input } from '@angular/core';
import { Franchise } from 'src/app/services/franchises.service';
import { Tenant, TenantsService } from 'src/app/services/tenants.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tenant-info',
  templateUrl: './tenant-info.component.html',
  styleUrl: './tenant-info.component.scss',
})
export class TenantInfoComponent {
  @Input() tenant!: Tenant;
  @Input() franchise?: Franchise;
  @Input() loadingRegistrationDb?: boolean;
  @Input() pafUUID?: string;

  readonly fieldLabelClass =
    'mb-0.5 text-xs font-semibold uppercase tracking-wide text-base-content/60';

  constructor(
    private tenantsService: TenantsService,
    private toastService: ToastService
  ) {}

  copyPafUuid(event?: Event) {
    event?.stopPropagation();
    if (!this.pafUUID) {
      return;
    }
    navigator.clipboard.writeText(this.pafUUID).then(() => {
      this.toastService.addToast('info', 'PAF UUID copied to clipboard');
    });
  }

  tenantAddressValid(tenant: Tenant) {
    return this.tenantsService.tenantAddressValid(tenant);
  }

  getQuickbooksCustomerLink(qboCustomerCode: string) {
    if (environment.production) {
      return (
        'https://qbo.intuit.com/app/customerdetail?nameId=' + qboCustomerCode
      );
    } else {
      return (
        'https://sandbox.qbo.intuit.com/app/customerdetail?nameId=' +
        qboCustomerCode
      );
    }
  }
}
